// extracted by mini-css-extract-plugin
export var deliveryRow = "_sk-a";
export var fixedHeight = "_sk-4";
export var freightLogo = "_sk-9";
export var fullWidth = "_sk-3";
export var priceColumn = "_sk-5";
export var radioSelected = "_sk-7";
export var radioUnselected = "_sk-6";
export var selectedOption = "_sk-2";
export var selectedOptionContainer = "_sk-1";
export var selection = "_sk-0";
export var tallSkeletonText = "_sk-8";